import actions from './actions';

const ClaimSettingPaymentLimitationModule = {
  namespaced: true,
  actions,
};

export default ClaimSettingPaymentLimitationModule;
